'use client'

import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'
import { Switch } from './Switch'

interface ToggleCardProps {
  title: ReactNode
  sub?: ReactNode
  on?: boolean
  onChange?: (next: boolean) => void
  disabled?: boolean
  children?: ReactNode
  className?: string
  style?: CSSProperties
}

export function ToggleCard({ title, sub, on, onChange, disabled, children, className, style }: ToggleCardProps) {
  const handle = (next: boolean) => {
    if (disabled) return
    onChange?.(next)
  }
  return (
    <div className={cx('st-tog-card', on && 'on', disabled && 'disabled', className)} style={style}>
      <div className="st-tog-top">
        <b>{title}</b>
        <Switch on={on} onChange={handle} />
      </div>
      {sub && <div className="st-tog-sub">{sub}</div>}
      {children}
    </div>
  )
}
